import React, { useCallback, useEffect, useState } from 'react';
import {
  IonPage,
  IonContent,
  useIonViewDidEnter,
  useIonViewWillLeave,
} from '@ionic/react';
import FarecardCappingCard from '../usecases/farecard/FarecardCappingCard';
import FarecardCappingCardComplete from '../usecases/farecard/FarecardCappingCardComplete';
import { FarecardCappingPot } from '../services/types/apitypes';
import { storageGetCappingPots, storageSetCappingPots } from '../utils/storage';
import { apiGetCappingPots } from '../services/api';
import useEnhancedAuth from '../EnhancedAuth';
import { useHistory, useParams } from 'react-router';
import AppPageHeader from '../components/AppPageHeader';
import { useTranslation } from 'react-i18next';

const CardFareCappingPage: React.FC = () => {
  const [t] = useTranslation('global');
  const auth = useEnhancedAuth();
  const router = useHistory();
  const { cardid } = useParams<{ cardid: string }>();

  const [inProgressPots, setInProgressPots] = useState<FarecardCappingPot[]>(
    [],
  );
  const [completedPots, setCompletedPots] = useState<FarecardCappingPot[]>([]);

  const [isPageActive, setIsPageActive] = useState(false);
  useIonViewDidEnter(() => {
    setIsPageActive(true);
  });
  useIonViewWillLeave(() => {
    setIsPageActive(false);
  });

  const goBack = () => {
    router.back();
  };

  const splitCappings = useCallback((cappings: FarecardCappingPot[]) => {
    setInProgressPots(
      cappings.filter((c) => Math.floor(c.currentValue / c.amount) < 1),
    );
    setCompletedPots(
      cappings.filter((c) => Math.floor(c.currentValue / c.amount) === 1),
    );
  }, []);

  useEffect(() => {
    let isMounted = true;

    const stored = storageGetCappingPots(cardid);
    if (stored && isMounted) splitCappings(stored);
    apiGetCappingPots(cardid, auth)
      .then((response) => {
        storageSetCappingPots(response.data, cardid!);
        isMounted && splitCappings(response.data);
      })
      .catch((e) => console.log('Could not get capping pots: ', e));

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <IonPage id='fare-capping-page'>
      <AppPageHeader
        isPageActive={isPageActive}
        back={() => goBack()}
        title={t('farecapping.title')}
      ></AppPageHeader>
      <IonContent fullscreen className="ion-padding default-content">
        <h4 className="fare-capping-title">{t("farecapping.earned")}</h4>
        {completedPots.map((pot) => (
          <FarecardCappingCardComplete key={pot.potId} pot={pot} />
        ))}
        <h4 className="fare-capping-title">{t("farecapping.inProgress")}</h4>
        {inProgressPots.map((pot) => (
          <FarecardCappingCard key={pot.potId} pot={pot} />
        ))}
      </IonContent>
    </IonPage>
  );
};

export default CardFareCappingPage;
